import React, { useContext, createContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';

import { getCssFileApiClient } from 'lib/SplashApiClient/subclients/CssFileApiClient';

export const CustomCssContext = createContext();

export const CustomCssContextProvider = ({ children, eventId, section, isEditing }) => {
    const [customCss, setCustomCss] = useState('');
    const cssFilesApiClient = useRef(getCssFileApiClient(eventId)).current;

    const { isLoading, isError } = useQuery(
        ['customCssFileStructure', eventId, section, isEditing],
        () => cssFilesApiClient.getCssFileBySection(section, isEditing),
        {
            select: (response) => response,
            onSuccess: (successData) => {
                const cssData = !successData ? '' : successData;
                setCustomCss(cssData);
            },
        },
    );

    const saveCode = (value, userId) => {
        cssFilesApiClient.saveCssFiles({ section, userId, document: value }).then(() => {
            setCustomCss(value);
        });
    };

    const value = { isLoading, isError, customCss, saveCode };
    return <CustomCssContext.Provider value={value}>{children}</CustomCssContext.Provider>;
};

CustomCssContextProvider.propTypes = {
    children: PropTypes.node,
    section: PropTypes.string,
    isEditing: PropTypes.bool,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CustomCssContextProvider.defaultProps = {
    children: null,
    section: '',
    isEditing: false,
};

export const useCustomCss = () => useContext(CustomCssContext);
